import { mediaData } from '@/mocks/home-data';

const mediaImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20silhouetted%20figure%20sitting%20in%20a%20dim%20interview%20room%20with%20a%20single%20warm%20overhead%20light%20creating%20dramatic%20shadows%2C%20documentary%20interview%20aesthetic%2C%20anonymous%20source%20atmosphere%2C%20high%20contrast%20black%20and%20warm%20tones%2C%20cinematic%20composition%2C%20editorial%20photography&width=900&height=506&seq=media-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20press%20conference%20podium%20with%20multiple%20microphones%20under%20bright%20stage%20lights%2C%20empty%20audience%20chairs%20in%20shadow%2C%20formal%20announcement%20atmosphere%2C%20warm%20spotlight%20on%20the%20podium%2C%20journalistic%20photography%20style%2C%20high%20detail%20editorial%20quality&width=900&height=506&seq=media-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=An%20artistic%20wall%20installation%20with%20interconnected%20red%20strings%20connecting%20photographs%20and%20newspaper%20clippings%20like%20an%20investigation%20board%2C%20warm%20ambient%20lighting%2C%20documentary%20investigation%20aesthetic%2C%20editorial%20photography%2C%20high%20detail%20composition&width=900&height=506&seq=media-03&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">媒体聚焦</h2>
          <p className="text-sm text-foreground-600">独家视频报道 · 深度调查解析</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={mediaImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}